import React from 'react';
import Icon from "../";
export default function IconCheckAltActive(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<rect width=\"24\" height=\"24\" fill=\"none\"/><path d=\"M12 2a10 10 0 1010 10A10 10 0 0012 2zm-1.58 15.18l-4.14-4.85.72-.65 3.39 4L16.94 8l.76.65z\" fill=\"#181818\"/>"
    }
  }));
}